import React, { useRef, useState } from 'react';
import styles from './styles';
import PropTypes from 'prop-types';
import emailjs from '@emailjs/browser';
import { Toaster, toast } from 'sonner';
import { completeFormEvent } from 'lib/events/fb-pixel/complete-form-event';

const EnquiryForm = ({ block }) => {
  if (!block) return '';
  const { primary } = block;
  const title1 = primary?.title1[0].text;
  const description = primary?.description[0].text;
  const emailCorp = primary?.email_to || "corporate@aftershockpc.com.au";

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [text, setText] = useState('');
  const [details, setDetails] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [sending, setSending] = useState(false);
  const [emailTo, setEmailTo] = useState(emailCorp);

  const sendEmail = (e) => {
    setSending(true);
    e.preventDefault();

    completeFormEvent({
      name: firstName,
      email: invoiceNumber,
      contactNumber: contactNumber,
    });

    emailjs.send('service_wk5wqzx', 'template_k7ax7qs', {
      first_name: firstName,
      last_name: lastName,
      contact_number: contactNumber,
      invoice_number: invoiceNumber,
      message: text,
      details: details,
      phone_number: phoneNumber,
      email_to: emailTo
    }, 'XdEbTw7FgavSpalUU')
      .then((result) => {
        setFirstName('');
        setLastName('');
        setContactNumber('');
        setInvoiceNumber('');
        setText('');
        setDetails('');
        setSending(false);
        toast.success("Successfully sent email!");
      }, (error) => {
        toast.error("Something went wrong!");
        console.log(error.text);
        setSending(false);
      });
  };

  const sendEmailMobile = (e) => {
    setSending(true);
    e.preventDefault();

    emailjs.send('service_wk5wqzx', 'template_vddwm7q', {
      phone_number: phoneNumber
    }, 'XdEbTw7FgavSpalUU')
      .then((result) => {
        setPhoneNumber('');
        setSending(false);
        toast.success("Successfully sent email!");
      }, (error) => {
        toast.error("Something went wrong!");
        console.log(error.text);
        setSending(false);
      });
  };

  const characterLimit = 2000;

  const handleChange = (event) => {
    const newText = event.target.value;
    if (newText.length <= characterLimit) {
      setText(newText);
    }
  };

  return (
    <>
      <Toaster position='top-center' richColors />
      <div className='main-container'>
        <div className='header-container'>
          <div className='header'>
            <img 
              draggable="false" 
              src='https://cdn.shopify.com/s/files/1/0522/3320/7988/files/support_hotline.png?v=1713873714' 
              className='header-icon' 
              alt='header-icon' 
            />
            <h3 className='title'>{title1}</h3>
          </div>
          <p className='description'>{description}</p>
        </div>

        <div className='input-section-desktop'>
          <form onSubmit={sendEmail}>
            <input className='input' type="text" hidden name="details" value={details} />
            <input className='input' type="text" hidden name="email_to" value={emailTo} />

            <div className='input-row'>
              <div className='input-container'>
                <div className='label-container'>
                  <label className='label'>First name</label><span className='required'>*</span>
                </div>
                <input required className='input' type="text" name="first_name" placeholder='First name' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
              </div>

              <div className='input-container'>
                <div className='label-container'>
                  <label className='label'>Last name</label><span className='required'>*</span>
                </div>
                <input required className='input' type="text" name="last_name" placeholder='Last name' value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>
            </div>

            <div className='input-row'>
              <div className='input-container'>
                <div className='label-container'>
                  <label className='label'>Contact Number</label><span className='required'>*</span>
                </div>
                <input
                  required
                  className='input'
                  pattern="\d*"
                  type="text"
                  name="contact_number"
                  placeholder='Contact Number'
                  value={contactNumber}
                  onChange={(e) => {
                    setContactNumber(e.target.value),
                      setDetails(`Contact Number: ${e.target.value} \n Email: ${invoiceNumber}`)
                  }}
                />
              </div>

              <div className='input-container'>
                <div className='label-container'>
                  <label className='label'>Email</label><span className='required'>*</span>
                </div>
                <input
                  className='input'
                  type="text"
                  name="invoice"
                  placeholder='Your Email Address'
                  value={invoiceNumber}
                  onChange={(e) => {
                    setInvoiceNumber(e.target.value)
                    setDetails(`Contact Number: ${contactNumber} \n Email: ${e.target.value}`)
                  }}
                />
              </div>
            </div>

            <div className='label-container'>
              <label required className='label'>What type of tasks do you plan to use your workstation for?</label><span className='required'>*</span>
            </div>
            <textarea
              required
              className='textarea' type="textarea" name="message" placeholder='Message'
              value={text}
              onChange={handleChange}
              rows={4}
              cols={50}
            />
            <div className='counter-container'>
              <p className='counter'>{text.length} / {characterLimit}</p>
            </div>

            <div className='submit-container'>
              <button className='submit' type="submit">
                {sending ? (
                  <>
                    {`Sending`}
                    <span className="loader" />
                  </>
                ) : (
                  "Send Message"
                )}
              </button>
            </div>
          </form>
        </div>

        <div className='input-section-mobile'>
          <form onSubmit={sendEmailMobile}>
            <input required className='input-mobile' type="text" name="phonenumber" placeholder='Your phone number' value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />

            <div className='submit-container'>
              <button className='submit' type="submit">
                {sending ? (
                  <>
                    {`Sending`}
                    <span className="loader" />
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};
EnquiryForm.propTypes = {
  block: PropTypes.shape({
    primary: PropTypes.shape({
      title1: PropTypes.array,
      description: PropTypes.array,
    }),
  }),
};

EnquiryForm.defaultProps = {
  block: null,
};

export default EnquiryForm;